/* unplugin-vue-components disabled */import { render } from "./icon-dislike.vue?vue&type=template&id=ec5dc0fe"
import script from "./icon-dislike.vue?vue&type=script&lang=js"
export * from "./icon-dislike.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/icon-dislike.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec5dc0fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec5dc0fe', __exports__)) {
    api.reload('ec5dc0fe', __exports__)
  }
  
  module.hot.accept("./icon-dislike.vue?vue&type=template&id=ec5dc0fe", () => {
    api.rerender('ec5dc0fe', render)
  })

}


export default __exports__